import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';
import { contractNameMapper, default as InfoText } from './CashlesInfoText';
import Snackbar from '@mui/material/Snackbar';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { _axios } from 'src/plugins/axios';

const SingleActionContent = ({ RequestDetails }) => {
  return (
    <DialogContentText>
      {RequestDetails ? (
        <InfoText
          keyValuePairs={[
            {
              key: 'RequestId',
              value: RequestDetails.requestid || null
            },
            {
              key: 'OrderId',
              value: RequestDetails.orderid || null
            },
            {
              key: 'Service',
              value: contractNameMapper(
                RequestDetails.service_type || null,
                'Cashless Medical Service'
              )
            },
            {
              key: 'Cashless Amount',
              value: RequestDetails.total_cashless_amount
            },
            {
              key: 'Corporate',
              value: RequestDetails.corporate_name || null,
              size: 8
            }
          ].filter((ele) => ele.value != null)}
        />
      ) : null}
    </DialogContentText>
  );
};

const BulkActionContent = ({ AggregateDetails }) => {
  return (
    <DialogContentText>
      {AggregateDetails ? (
        <InfoText
          textAlign={'left'}
          keyValuePairs={[
            {
              key: 'Total Reqs',
              value: AggregateDetails.num_requests || null,
              size: 3
            },
            {
              key: 'Corporates',
              value: AggregateDetails.total_number_of_corporates || null,
              size: 4
            },
            {
              key: 'Total Cashless',
              value:
                '₹ ' +
                  (
                    Math.round(AggregateDetails.total_cashless * 100) / 100
                  ).toString() +
                  '/-' || null,
              size: 5
            }
            /* {
              key: 'Services',
              value: AggregateDetails.unique_services
                ? AggregateDetails.unique_services
                    .map((ele) => contractNameMapper(ele, 'Miscellaneous'))
                    .filter(onlyUnique)
                    .join(', ')
                : null,
              size: 4
            } */
          ].filter((ele) => ele.value != null)}
        />
      ) : null}
    </DialogContentText>
  );
};

export default function CashlessActionDialog({
  openStatus,
  closeDialogHandler,
  isRejection,
  title,
  innerActionConent,
  requestids
}) {
  const [remarks, setRemarks] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [submitSuccess, setSubmitSuccess] = React.useState(false);
  const [submitPrevFail, setSubmitPrevFail] = React.useState(false);

  const notifySuccess = () => {
    setSubmitSuccess(true);
    setSubmitPrevFail(false);
    setSnackbarOpen(true);
  };

  const notifyFailure = () => {
    setSubmitSuccess(false);
    setSubmitPrevFail(true);
    setSnackbarOpen(true);
  };

  const updateCashlessRequestStatusesAndRemarks = (obj = {}) => {
    console.log('once');
    setLoading(true);
    console.log(requestids);
    _axios
      .post(
        'cashless',
        {
          remark: remarks,
          status: isRejection ? 'Rejected' : 'Approved',
          requestids: requestids
        },
        {
          ignoreLoading: true
        }
      )
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          notifySuccess();
        } else {
          notifyFailure();
        }
      })
      .catch((error) => {
        notifyFailure();
      });
  };

  const handleClose = (ignore_refetch) => {
    closeDialogHandler(ignore_refetch);
    setSnackbarOpen(false);
    setLoading(false);
  };

  const handleSubmit = () => {
    updateCashlessRequestStatusesAndRemarks();
  };

  const handleUpdateRemarks = (e) => {
    if (e.target && e.target.value) {
      setRemarks(e.target.value);
    }
  };

  const handleSubmitRetry = () => {
    setLoading(false);
    setSnackbarOpen(false);
    setSubmitSuccess(false);
    handleSubmit();
  };

  const action = (
    <React.Fragment>
      {!submitSuccess ? (
        <Button color="warning" size="small" onClick={handleSubmitRetry}>
          RETRY
        </Button>
      ) : (
        <Button
          color="inherit"
          size="small"
          onClick={() => {
            handleClose(false);
          }}
        >
          OKAY
        </Button>
      )}
      <IconButton
        size="small"
        aria-label="close"
        color={'inherit'}
        onClick={() => {
          handleClose(false);
        }}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div>
      <Dialog
        open={openStatus}
        onClose={() => {
          handleClose(true);
        }}
        fullWidth
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          {innerActionConent}
          <TextField
            autoFocus
            margin="dense"
            id="name"
            disabled={loading}
            required={isRejection && remarks.length <= 0}
            label="Remarks"
            type="text"
            fullWidth
            variant="standard"
            onChange={handleUpdateRemarks}
          />
        </DialogContent>
        {!loading ? (
          <DialogActions>
            <Button
              onClick={() => {
                handleClose(true);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleSubmit}
              disabled={isRejection && remarks.length <= 0}
            >
              Confirm
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            {!snackbarOpen ? (
              <CircularProgress color="info" />
            ) : submitSuccess ? (
              <Grid container direction="row" alignItems="center">
                <Grid item lg={10} md={10} sm={10} />
                <Grid item>
                  <CheckIcon fontSize="large" color="success" />
                </Grid>
                <Grid item>
                  <strong>Success!</strong>
                </Grid>
              </Grid>
            ) : (
              <Grid container direction="row" alignItems="center">
                <Grid item lg={10} md={10} sm={10} />
                <Grid item>
                  <CloseIcon fontSize="large" color="error" />
                </Grid>
                <Grid item>
                  <strong>Failed!</strong>
                </Grid>
              </Grid>
            )}
          </DialogActions>
        )}
      </Dialog>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={snackbarOpen}
        onClose={() => {
          handleClose(false);
        }}
        message={
          submitSuccess
            ? 'Successfully udpdated claim details'
            : 'Error updating claim details'
        }
        key={'top-center'}
        action={action}
        ContentProps={{
          sx: {
            background: submitSuccess ? 'green' : 'red'
          }
        }}
      />
    </div>
  );
}

export { SingleActionContent, BulkActionContent };
